export class SymmetryMetricModel {
  ag!: string[];
  d!: number;
  hr!: string;
  singleHr!: string;
  val!: string;
  ver!: string;

  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   */
  gmc!: number;
}

export default class SymmetryMetric extends SymmetryMetricModel {
  rg: string;

  constructor({ ag, d, hr, singleHr, val, ver, gmc }: SymmetryMetricModel) {
    super();

    this.ag = ag;
    this.d = d;
    this.hr = hr;
    this.singleHr = singleHr;
    this.val = Number(val).toFixed(2);
    this.ver = ver;
    this.rg = val;
    this.gmc = gmc;
  }
}
